import React from 'react';
import { SocialBereich } from '@/vendor/thundercontent-hub/react';
import { useAuth } from '@/components/auth/use-auth';
import { CONTENT_HUB_BASE, hubHeaders } from '@/lib/api/contentHub';
import '@/styles/content-hub.css';

/**
 * Social — der fertige Bereich aus `@thundercontent/hub/react`, unverändert.
 *
 * Welche Reiter erscheinen (Ideen, später Planung), entscheidet die Engine über
 * die gebuchten Module — nicht das Office. Die Optik kommt ausschließlich über
 * die `--ch-*`-Variablen in `styles/content-hub.css`.
 */
const CmsSocialPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Social</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Video-Ideen aus ThunderContent — Formate, die bei anderen Konten gerade deutlich besser
          laufen als sonst, übersetzt für die Musikschule.
        </p>
      </div>
      <div className="sidigo-content-hub rounded-lg border border-border bg-card p-4 sm:p-6">
        <SocialBereich basePath={CONTENT_HUB_BASE} headers={hubHeaders} userName={user?.name ?? ''} />
      </div>
    </div>
  );
};

export default CmsSocialPage;
